import React from "react";

function LandingIntro() {
  window.scrollTo(0, 0); // scroll to top of page

  return (
    <section className="card-intro-landing">
      <div className="folio-intro">
        {/* <h2 className="folio-intro-title">
          <span>Martin Duggan</span>
          <span>Product Designer</span>
        </h2> */}
        <figure className="folio-intro-illustration">
          <span className="intro-circles circle01">
            <i className="top"></i>
            <i className="right"></i>
            <i className="bottom"></i>
            <i className="left"></i>
            <label>User Research</label>
          </span>
          <span className="intro-circles circle02">
            <i className="top"></i>
            <i className="right"></i>
            <i className="bottom"></i>
            <i className="left"></i>
            <label>
              Synthesis <br /> &amp; Ideation
            </label>
          </span>
          <span className="intro-circles circle03">
            <i className="top"></i>
            <i className="right"></i>
            <i className="bottom"></i>
            <i className="left"></i>
            <label>
              Design <br /> &amp; Prototyping
            </label>
          </span>
          <span className="intro-circles circle04">
            <i className="top"></i>
            <i className="right"></i>
            <i className="bottom"></i>
            <i className="left"></i>
            <label>
              Release <br /> &amp; Iterate
            </label>
          </span>
        </figure>
        <article className="text">
          <p>
            I am a designer who is motivated by product strategy,{" "}
            <span>UX practices</span>, UI design, and front-end development. I
            am continually growing my knowledge, skills, and experience across
            these domains to bring value-driven design to{" "}
            <span>e-commerce</span> platforms and enterprise applications.
          </p>
          <p>
            I believe collaboration is the key to success. I have lead front-end
            design for multi-disciplinary teams of Systems Architects, Product
            Owners, Software Developers, QA testers, Commercial and Marketing
            specialists.
          </p>
          <p>
            This portfolio site includes case studies of recent work as well as
            my latest resume.
          </p>
        </article>
      </div>
      <i className="icon-scroll-down"></i>
    </section>
  );
}

export default LandingIntro;
